import { ChevronExpandedIcon, FullSizeIcon, IconSizeEnum } from '@acceso/design-system';
import { useState } from 'react';

type VolumeControlProps = {
  onChangeWidth: (value: '20%' | '50%' | '100%') => void;
  onFullscreen: () => void;
};

export function FullscreenControl({ onFullscreen, onChangeWidth }: VolumeControlProps) {
  const [showRange, setShowRange] = useState<boolean>(false);

  const handleButtonClick = (callback: () => void) => (e: React.MouseEvent) => {
    e.stopPropagation();
    callback();
  };

  const percentageButtons = ['20%', '50%', '100%'].map(percentage => ({
    label: percentage,
    icon: '',
    onClick: handleButtonClick(() => {
      setShowRange(false);
      onChangeWidth(percentage as '20%' | '50%' | '100%');
    }),
  }));

  // Botón de fullscreen
  const fullscreenButton = {
    label: '',
    icon: <FullSizeIcon size={IconSizeEnum.SM} />,
    onClick: handleButtonClick(onFullscreen),
  };

  const ALL_BUTTONS = [...percentageButtons, fullscreenButton];

  return (
    <div className="relative flex items-center">
      <ChevronExpandedIcon
        size={IconSizeEnum.SM}
        className="cursor-pointer"
        onClick={e => {
          e.stopPropagation();
          setShowRange(prev => !prev);
        }}
      />
      {showRange && (
        <div className="rounded-semif absolute -left-[10px] bottom-[20px] z-50 bg-bg-primary-10 p-2">
          {ALL_BUTTONS.map(({ label, icon, onClick }, index) => (
            <>
              <button
                key={index}
                onClick={onClick}
                className="flex w-full items-center justify-center p-1 !text-tiny hover:bg-slate-300"
              >
                {label || icon}
              </button>
              {index !== ALL_BUTTONS.length - 1 && <hr />}
            </>
          ))}
        </div>
      )}
    </div>
  );
}
